jQuery(document).ready(function() {

    if(jQuery('.product-container')) {
        function selectMaat() {
            const element = jQuery(this);
            const var_id = element.data('variant-id');
            jQuery('product-maat-options').attr("data-activevariant", var_id);
            jQuery('product-maat-options').trigger('data-attribute-changed');
        };
        jQuery('product-maat-options .maat').on('click', this, selectMaat);
    };

    function fetchConfig(type = 'json') {
        return {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
        };
    }

    function addToCart(event) {

        event.preventDefault();
        const var_id = jQuery('product-maat-options').attr('data-activevariant');

        if(var_id) {
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(document.getElementById('add-to-cart-form-product-single'));
            config.body = formData;

            const routeUrl = JSON.parse(document.querySelector('.cart-url [type="application/json"]').textContent)

            fetch(routeUrl, config).then(response => {
            }).catch((err) => {
                console.error(err);
            }).finally(() => {
                jQuery('#cart-slideout').load(" #cart-slideout > *", function() {
                    // reload Sauce basket upsell gallery
                    let scriptTag = document.createElement("script");
                    scriptTag.classList.add('snapppt-widget');
                    scriptTag.classList.add('sauce-basket-upsell');
                    scriptTag.setAttribute('loadr', 'instant');
                    scriptTag.src = 'https://app.addsauce.com/widgets/basket_upsell/ef91ef5c-0d7f-2a94-707c-039c4d4bda08/page-gilet.js';
                    let container = jQuery('#cart-slideout .snpt-widgt--basket-upsell')[0];
                    container.appendChild(scriptTag);
                })
                jQuery('.slideout.cart-slideout').removeClass('active').addClass('active');
                jQuery('header .top-nav .top-nav-right a.icon-cart').load(" header .top-nav .top-nav-right a.icon-cart > *");
            })
        } else {
            jQuery('.voorraad .none-is-selected').removeClass('active').addClass('active');
        }

        
    };

    jQuery('.product-container button.add-to-cart-form').on('click', addToCart.bind(this));

    class ProductMaatOptions extends HTMLElement {

        constructor() {
            super();
            jQuery(this).on('data-attribute-changed', this.onVariantChange);
        }
    
        onVariantChange() {
            let activeVariantID = jQuery(this).attr('data-activevariant');
            let variantData = this.getVariantData(activeVariantID);
            this.updateAddToCart(activeVariantID, variantData.available);
            this.updateAddToCartWarning();
            this.updateMaten(activeVariantID);
            this.updateVoorraad(variantData.available);
            this.updatePrijs(variantData.compare_at_price, variantData.price, variantData);
            this.updateURL(activeVariantID);
            this.updateVoorraad();
            this.updateHeader();
        }

        getVariantData(variantID) {
            this.variants = this.variants || JSON.parse(document.querySelector('.product-container [type="application/json"]').textContent);
            const activeVariant = this.variants.filter((val) => val.id == variantID)[0];
            return activeVariant;
        }
    
        updateAddToCart(variant, available) {
            jQuery('form.add-to-cart-form input[name=id]').val(variant);
            if(available) {
                jQuery('.single-product-nav .addtocart').removeClass('available');
                jQuery('.single-product-nav .addtocart').addClass('available');

            } else {
                jQuery('.single-product-nav .addtocart').removeClass('available');
            }
        }

        updateAddToCartWarning() {
            jQuery('.voorraad .none-is-selected').removeClass('active');
        }

        updateMaten(variantID) {
            jQuery('product-maat-options .maat').removeClass('active');
            jQuery('.maat[data-variant-id="' + variantID + '"]').addClass('active');
        }

        updateVoorraad(available) {
            const productNav = jQuery('.product-container .voorraad');
            productNav.removeClass('available');
            if(available) {
                productNav.addClass('available');
            }
        }

        updatePrijs(compareAtPrice, price, d) {
            if(compareAtPrice) {
                const cp = compareAtPrice.toString();
                const newComparePrice = '€' + cp.substring(0, cp.length - 2) + ',' + cp.substring(cp.length - 2);
                jQuery('.product-container .price .compare').text(newComparePrice);
            }
            const p = price.toString();
            const newPrice = '€' + p.substring(0, p.length - 2) + ',' + p.substring(p.length - 2);
            jQuery('.product-container .price .final').text(newPrice);
        }

        updateURL(variantID) {
            window.history.replaceState({}, '', window.location.pathname + '?variant=' + variantID);
        }

        updateVoorraad() {
            jQuery(".voorraad-container").load(" .voorraad-container > *");
        }

        updateHeader() {
            jQuery('header .top-nav .top-nav-right a.icon-cart').load(" header .top-nav .top-nav-right a.icon-cart > *");
        }
    
    }
    
    customElements.define('product-maat-options', ProductMaatOptions);
})